<h3>{{data.head}}</h3>
<hr>
<div *ngIf="data.head.includes('Image')">
  <app-image-viewer [images]="data.fileUrls" [idContainer]="'idOnHTML'" [loadOnInit]="true"
    [rotate]="false" [showPDFOnlyOption]="false" primaryColor="#144677" [download]="true"
    openInNewTabTooltipLabel="Download">
  </app-image-viewer>
</div>
<div *ngIf="data.head=='Video'" style="text-align: center;">

  <video width="600" height="240" controls>
    <source [src]="data.fileUrls" type="video/mp4">
    <source [src]="data.fileUrls" type="video/ogg">
    Your browser does not support the video tag.
  </video>

</div>

<button mat-icon-button (click)="onNoClick()">
  <mat-icon>close</mat-icon>
</button>